import React from 'react';
import styled from 'styled-components';
import FormInput from '../molecules/FormInput';
import FormTitle from '../molecules/FormTitle';
import FormSelect from '../molecules/FormSelect';
import { COUNTRIES } from '../../../utils/constants';

const Delivery = ({ register, errors }: any) => {
  return (
    <Form>
      <FormTitle title={'DELIVERY'} />
      <FormSelect
        {...register('country', { required: `Field is required`.toUpperCase() })}
        placeholder="COUNTRY"
        options={COUNTRIES.map((country) => country.name)}
      />
      {errors.country && <ErrorText>{errors.country.message}</ErrorText>}

      <FormInput
        type="text"
        placeholder="LAST NAME"
        {...register('lastName', { required: `last Name is required`.toUpperCase() })}
      />
      {errors.lastName && <ErrorText>{errors.lastName.message}</ErrorText>}

      <FormInput
        type="text"
        placeholder="FIRST NAME"
        {...register('firstName', { required: `first Name is required`.toUpperCase() })}
      />
      {errors.firstName && <ErrorText>{errors.firstName.message}</ErrorText>}

      <FormInput
        type="text"
        placeholder="STREET ADDRESS/BARANGAY"
        {...register('street', { required: `street is required`.toUpperCase() })}
      />
      {errors.street && <ErrorText>{errors.street.message}</ErrorText>}

      <FormInput
        type="text"
        placeholder="CITY/MUNICIPALITY"
        {...register('city', { required: `CITY/MUNICIPALITY is required`.toUpperCase() })}
      />
      {errors.city && <ErrorText>{errors.city.message}</ErrorText>}

      <FormInput
        type="text"
        placeholder="PROVINCE"
        {...register('province', { required: `PROVINCE is required`.toUpperCase() })}
      />
      {errors.province && <ErrorText>{errors.province.message}</ErrorText>}

      <FormInput
        type="number"
        placeholder="ZIP/POSTAL CODE"
        {...register('zip', { required: `ZIP/POSTAL CODE is required`.toUpperCase() })}
      />
      {errors.zip && <ErrorText>{errors.zip.message}</ErrorText>}
    </Form>
  );
};

const Form = styled.div`
  padding: 0.5rem 0rem;
`;

const ErrorText = styled.span`
  color: red;
  font-size: 0.75rem;
`;

export default Delivery;
